import type { WidgetEntity } from 'src/entities/widget/WidgetEntity';
import type { TSerializedWidget } from 'src/entities/workspace/types';
import { requireService } from 'src/packages/di';

export function serializeWidgets(widgets: WidgetEntity[]): TSerializedWidget[] {
  return widgets
    .slice()
    .sort((a, b) => a.zIndex - b.zIndex)
    .map((widget) => {
      return serializeWidget(widget);
    });
}

function serializeWidget(widget: WidgetEntity): TSerializedWidget {
  const serializeWidgetService = requireService('widgetSerializer');

  return serializeWidgetService.serialize(widget);
}
